import * as devisConf from '@/configuration/devisConf';
import calculArrondi from '@/services/calcul/calculArrondi';
import calculLignesRemise from '@/services/devisCommandes/calcul/calculLignesRemise';
import calculTauxRemise from '@/services/devisCommandes/calcul/calculTauxRemise';

export function calculLigneCommandeRemise(ligneCommande) {
  ligneCommande.totalHt = ligneCommande.totalAvantRemise;
  if (ligneCommande.typeRemise === null || ligneCommande.typeRemise === undefined) {
    return;
  }

  switch (ligneCommande.typeRemise) {
    case devisConf.MONTANT:
      if (ligneCommande.remise === null
        || ligneCommande.remise === undefined
        || Number.isNaN(ligneCommande.remise)
      ) {
        break;
      }
      ligneCommande.totalHt = calculArrondi(
        ligneCommande.totalAvantRemise + ligneCommande.remise,
      );
      break;
    case devisConf.POURCENTAGE:
      if (ligneCommande.remise === null
          || ligneCommande.remise === undefined
          || Number.isNaN(ligneCommande.remise)
      ) {
        break;
      }
      ligneCommande.totalHt = calculArrondi(
        ligneCommande.totalAvantRemise
        + ligneCommande.totalAvantRemise * ligneCommande.remise
        / 100,
      );
      break;
    case devisConf.PERSONALISE:
      calculLignesRemise(ligneCommande);
      break;
    default:
      break;
  }
}

export function miseAJourLignesNormales(ligneRemise, lignesCommandeNormales) {
  if (!ligneRemise.typeRemise) {
    lignesCommandeNormales.forEach(ligne => {
      ligne.totalHtAvecLigneRemise = ligne.totalHt;
    });
    return;
  }

  let remise = ligneRemise.remise;
  if (ligneRemise.typeRemise === devisConf.MONTANT) {
    remise = calculTauxRemise(ligneRemise.remise, devisConf.MONTANT, ligneRemise.totalAvantRemise);
  }

  let soulte = 0;
  let sommeTotalHtAvecLigneRemise = 0;
  let sommeTotalHt = 0;
  lignesCommandeNormales.forEach((ligneNormale) => {
    const remiseGlobaleLigne = (ligneNormale.totalHt * remise / 100) + soulte;
    const remiseGlobaleLigneArrondie = calculArrondi(remiseGlobaleLigne);
    soulte = remiseGlobaleLigne - remiseGlobaleLigneArrondie;
    ligneNormale.totalHtAvecLigneRemise = calculArrondi(
      ligneNormale.totalHt + remiseGlobaleLigneArrondie,
    );
    sommeTotalHtAvecLigneRemise += ligneNormale.totalHtAvecLigneRemise;
    sommeTotalHt += ligneNormale.totalHt;
  });
  const diffRemise = ligneRemise.totalHt + sommeTotalHt - sommeTotalHtAvecLigneRemise;
  if (diffRemise === 0) return;
  const limite = 0.05;
  if (diffRemise < limite) {
    const lignes = lignesCommandeNormales.filter(ligne => {
      return ligne.totalHtAvecLigneRemise > limite;
    });
    if (lignes.length > 0) {
      lignes[0].totalHtAvecLigneRemise += diffRemise;
    }
  }
}
